export default __webpack_public_path__ + "static/media/stage_handover.38b44898.svg";